import { Badge } from '@/components/ui/badge';
import { ParkingSquare, LogOut, HelpCircle, Ban } from 'lucide-react';
import { getStatusBadgeVariant } from './utils';
import type { ParkingSessionDisplayStatus } from './types';

interface ParkingSessionStatusBadgeProps {
	status?: ParkingSessionDisplayStatus;
}

interface ParkingSessionStatusIconProps {
	status?: ParkingSessionDisplayStatus;
	className?: string;
}

export const ParkingSessionStatusIcon = ({ status, className = 'w-4 h-4' }: ParkingSessionStatusIconProps) => {
	switch (status) {
		case 'Inside':
			return <ParkingSquare className={className} />;
		case 'Exited':
			return <LogOut className={className} />;
		case 'Canceled':
			return <Ban className={className} />;
		default:
			return <HelpCircle className={className} />;
	}
};

export const ParkingSessionStatusBadge = ({ status }: ParkingSessionStatusBadgeProps) => {
	const label = status ?? 'Unknown';
	const variant = getStatusBadgeVariant(status);

	return (
		<Badge variant={variant} className="gap-1.5">
			<ParkingSessionStatusIcon status={status} className="w-3.5 h-3.5" />
			{label}
		</Badge>
	);
};
